import { useAtomValue } from 'jotai';
import { orderBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import { playerPositionsAndMinutesAtom } from '@/atoms/queries/player/playerPositions';
import { SORT_DIRECTION } from '@/types/ordering';

const minPlayed90s = 1;
const maxVisiblePositions = 3;

export const usePlayerPositionsInfo = () => {
  const { t } = useTranslation(['general', 'events']);
  const { playerPositions } = useAtomValue(playerPositionsAndMinutesAtom);

  // We always want to at least return the most played position, in case none of the positions played meet the minimum threshold
  const significantPositions = Object.entries(playerPositions).filter(
    ([_, played90s], index) => index === 0 || played90s >= minPlayed90s,
  );

  // order the positions by played 90s, from highest to lowest played
  const sortedPositions = orderBy(significantPositions, ([, played90s]) => played90s, [SORT_DIRECTION.DESC]);

  const positions = sortedPositions.map(([position]) =>
    t(`fields.event.attributes.playerPosition.${position}`, { ns: 'events' }),
  );

  if (positions.length <= maxVisiblePositions) {
    return positions.join(', ');
  }

  const mostPlayedPositions = positions.slice(0, maxVisiblePositions).join(', ');
  const hiddenPositionsIndicator = t('plusMore', { count: positions.length - maxVisiblePositions });

  return `${mostPlayedPositions} ${hiddenPositionsIndicator}`;
};
